import moment from 'moment';

export const CHECKSUMS_INTERVAL = 1000 * 60 * 10;
export const CHECKSUMS_INTERVAL_NEXT = 1000 * 60 * 60;
export enum KeyCode {
  Enter = 13,
  Space = 32,
  Comma = 188,
  Delete = 46,
  Backspace = 8
}

export enum Key {
  Enter = 'Enter',
  Space = ' ',
  Comma = ',',
  Delete = 'Delete',
  Backspace = 'Backspace'
}

export const NEW_BILLING_DATE_CUTOFF_MOMENT = process.env.REACT_APP_NEW_BILLING_DATE_CUTOFF
  ? moment(process.env.REACT_APP_NEW_BILLING_DATE_CUTOFF).startOf('day')
  : undefined;

export const NEW_BILLING_DATE_CUTOFF_DATE = NEW_BILLING_DATE_CUTOFF_MOMENT?.toDate();
